import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import des traductions françaises
import commonFR from './fr/common.json';
import suggestionsFR from './fr/suggestions.json';
import exploreFR from './fr/explore.json';
import authFR from './fr/auth.json';
import notificationsFR from './fr/notifications.json';
import postsFR from './fr/posts.json';
import profileFR from './fr/profile.json';
import wizardFR from './fr/wizard.json';
import settingsFR from './fr/settings.json';
import onboardingFR from './fr/onboarding.json';

// Import des traductions anglaises
import commonEN from './en/common.json';
import suggestionsEN from './en/suggestions.json';
import exploreEN from './en/explore.json';
import authEN from './en/auth.json';
import notificationsEN from './en/notifications.json';
import postsEN from './en/posts.json';
import profileEN from './en/profile.json';
import wizardEN from './en/wizard.json';
import settingsEN from './en/settings.json';
import onboardingEN from './en/onboarding.json';

const resources = {
  fr: {
    common: commonFR,
    suggestions: suggestionsFR,
    explore: exploreFR,
    auth: authFR,
    notifications: notificationsFR,
    posts: postsFR,
    profile: profileFR,
    wizard: wizardFR,
    settings: settingsFR,
    onboarding: onboardingFR
  },
  en: {
    common: commonEN,
    suggestions: suggestionsEN,
    explore: exploreEN,
    auth: authEN,
    notifications: notificationsEN,
    posts: postsEN,
    profile: profileEN,
    wizard: wizardEN,
    settings: settingsEN,
    onboarding: onboardingEN
  }
};

// Langues supportées
const SUPPORTED_LANGUAGES = ['fr', 'en'];

// Fonction pour changer la langue
export const changeLanguage = async (language) => {
  if (!SUPPORTED_LANGUAGES.includes(language)) {
    console.error('Langue non supportée:', language);
    return false;
  }
  
  // Vérifier si la langue est déjà définie
  if (i18n.language === language) {
    return true; // Langue déjà définie, pas besoin de changer
  }
  
  try {
    // Sauvegarder dans localStorage
    localStorage.setItem('language', language);
    
    // Appliquer le changement de langue
    await i18n.changeLanguage(language);
    document.documentElement.lang = language;
    
    return true;
  } catch (error) {
    console.error('Erreur lors du changement de langue:', error);
    return false;
  }
};

// Récupérer la langue des préférences utilisateur
const getUserLanguage = () => {
  const savedLanguage = localStorage.getItem('language');
  
  if (savedLanguage && SUPPORTED_LANGUAGES.includes(savedLanguage)) {
    return savedLanguage;
  }
  
  const browserLang = navigator.language.substring(0, 2);
  const defaultLang = SUPPORTED_LANGUAGES.includes(browserLang) ? browserLang : 'fr';
  return defaultLang;
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getUserLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    ns: ['activities', 'common', 'suggestions', 'profile', 'explore', 'auth', 'notifications', 'wizard', 'settings', 'onboarding'],
    defaultNS: 'common'
  });

// Exposer une fonction pour mettre à jour la langue depuis les préférences Firestore
export const updateLanguageFromPreferences = (preferences) => {
  try {
    if (!preferences) {
      return false;
    }
    
    const { language } = preferences;
    
    if (!language || !SUPPORTED_LANGUAGES.includes(language)) {
      return false;
    }
    
    // Vérifier si la langue actuelle est différente
    const currentLanguage = i18n.language;
    if (currentLanguage === language) {
      return true;
    }
    
    // Mettre à jour la langue
    changeLanguage(language);
    return true;
  } catch (error) {
    console.error('Erreur lors de la mise à jour de la langue depuis les préférences:', error);
    return false;
  }
};

export default i18n;
